import {Credentials, Email, Hmac, Option, UpdateUser, ResetPassword, Token} from '../../Config/dataModel';
import {forgotPassword, login, logout, resetPassword, setSelectedInsurer, updateUser, validateIdentityNo, resetSecret, hideMaintenance} from '../Actions/authAction';

export default (dispatch) => {
    return {
        login: (credential: Credentials) => {
            dispatch(login(credential))
        },
        logout: () => {
            dispatch(logout());
        },
		forgotPassword: (data: Email) => {
			dispatch(forgotPassword(data));
		},
		resetPassword: (data: ResetPassword) => {
			dispatch(resetPassword(data)).then(logout);
		},
		updateUser: (data: UpdateUser) => {
			dispatch(updateUser(data));
		},
        validateIdentityNo: (hmac: Hmac) => {
            dispatch(validateIdentityNo(hmac));
        },
        setSelectedInsurer: (insurer: Option) => {
            dispatch(setSelectedInsurer(insurer));
        },
        resetSecret: (data: Token) => {
            dispatch(resetSecret(data));
        },
        hideMaintenance: () => {
            dispatch(hideMaintenance());
        }
    };
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Dispatch/authDispatch.ts